export const GET_PRODUCT = gql`
    query GetProduct($id: Int!) {
        product(id: $id) {
            id
            name
            type
            status
            catalogue
            imageUrl
            primaryProducts {
                id
                name
                catalogue
                type
                status
            }
            secondaryProducts {
                id
                name
                status
                catalogue
                type
                status
            }
            description {
                type
                text
            }
            createdAt
            onlineId
            terminalId
            countries {
                alpha2Code
                name
            }
        }
    }
`;

export const GET_PRODUCTS = gql`
    query GetProducts {
        products {
            id
            name
            type
            catalogue
            status
            onlineId
            terminalId
            countries {
                alpha2Code
                name
            }
        }
    }
`;

export const FIND_PRIMARY_PRODUCT_MUTATION = gql`
    query FindPrimaryProduct($name: String!, $type: ProductType, $page: PageFilters) {
        findPrimaryProduct(name: $name, type: $type, page: $page) {
            total
            page
            pageSize
            data {
                id
                name
                type
                imageUrl
                catalogue
                term
                connectivity
                secondaryProductIds
                countries {
                    alpha2Code
                    name
                }
            }
        }
    }
`;
